export default ({ redirect, route, store }) => {
  const url = route.path.split('/')[1]
  const eventsOnly = store.getters.settings?.events?.only_sell_via_events

  if (url === 'shop' && eventsOnly) {
    redirect('/events')
  }
}
